import taskFrame from "../assets/images/icons/Rectangle 12 (1).svg";
import horseIcon from "../assets/images/icons/horse.svg";
import headIcon from "../assets/images/icons/head.svg";
import riderIcon from "../assets/images/icons/Vector-1.svg";
import EstateActivityLayout from "../components/EstateActivityLayout";
import { useTranslation } from "../components/Localization";

export default function EstateSoldierTaskPage() {
  const { t } = useTranslation();
  return <EstateActivityLayout taskKey="soldier" step={1} progressIcon="left" backTo="/petkiek/konyv" nextTo="/petkiek/csaladfa">
    <button className="task-icon-button estate-soldier" aria-label={t("accessibility.soldierAudio")}><img className="task-frame" src={taskFrame} alt="" /><span className="estate-soldier-rider" aria-hidden="true"><img className="estate-soldier-head" src={headIcon} alt="" /><img className="estate-soldier-body" src={riderIcon} alt="" /><img className="estate-soldier-horse" src={horseIcon} alt="" /></span></button>
  </EstateActivityLayout>;
}
